export enum MeasureConstraint {
    GREATER_THAN_0 = 'greaterThan0',
    MANUALLY_ENTERED = 'manuallyEntered',
}
